import {APIClient} from '../backend/ApiClient';
import {useEffect, useState} from 'react';
import {LabelDTO} from '../models/dto/LabelDTO';

export const useGetLabelData = () => {
    const apiClient = APIClient();

    let [existingLabelData, setExistingLabel] = useState<LabelDTO[]>([]);
    const getData = apiClient.getLabelData;
    const setExistingLabelCall = async () => {
        existingLabelData = await getData();
        setExistingLabel(existingLabelData);
    };

    useEffect(() => {
        setExistingLabelCall().catch();
    }, []);

    return {existingLabelData}
};
